import packageJson from '../../package.json';

/**
 * Gets the current application version
 * First tries to load from version.json (which would be updated during deployment)
 * Falls back to package.json version if version.json fetch fails
 * @returns {Promise<string>} Promise resolving to version string
 */
export const getAppVersion = async () => {
  try {
    // Try to get version from version.json (useful for deployment updates)
    const response = await fetch('/version.json');
    if (response.ok) {
      const data = await response.json();
      return data.version;
    }
  } catch (error) {
    console.warn('Could not load version from version.json:', error);
  }

  // Fall back to package.json version
  return packageJson.version;
};

/**
 * Gets the version synchronously from package.json
 * This is a fallback for components that can't use async functions
 * @returns {string} Version string
 */
export const getAppVersionSync = () => {
  return packageJson.version;
}; 